import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterProvidersView.
 * @extends JetView
 */
export default class FilterProvidersView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country options
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Conditional visibility based on configuration
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for secondary country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Make this field read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country options
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Conditional visibility based on configuration
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry country-hide', // CSS classes for styling
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a8',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a8',
                    cols: [
                        {
                            view: 'text',
                            name: 'Names',
                            minWidth: 200,
                            label: _('Nombres:'), // Label for names input
                            labelPosition: 'top',
                            placeholder: _('Nombres'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Lastname',
                            minWidth: 200,
                            label: _('Apellidos:'), // Label for last names input
                            labelPosition: 'top',
                            placeholder: _('Apellidos'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Phone',
                            minWidth: 200,
                            label: _('Teléfono:'), // Label for phone input
                            labelPosition: 'top',
                            placeholder: _('Teléfono'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Skype',
                            minWidth: 200,
                            label: _('Skype:'), // Label for Skype input
                            labelPosition: 'top',
                            placeholder: _('Skype'), // Placeholder text
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a8',
                    cols: [
                        {
                            view: 'text',
                            name: 'Address',
                            minWidth: 200,
                            label: _('Dirección:'), // Label for address input
                            labelPosition: 'top',
                            placeholder: _('Dirección'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Email',
                            minWidth: 200,
                            label: _('Email:'), // Label for email input
                            labelPosition: 'top',
                            placeholder: _('Email'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Company',
                            minWidth: 200,
                            label: _('Empresa:'), // Label for company input
                            labelPosition: 'top',
                            placeholder: _('Empresa'), // Placeholder text
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the first set of filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Contains the second set of filters
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Contains the second set of filters
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout adjustment
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'), // Button label for clearing filters
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                this.getRoot().clear(); // Clears the form inputs
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Consultar'), // Button label for submitting filters
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get values from the form
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('managementContact:filter', [
                                    filterdata, // Trigger filter event with collected data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Button label for clearing filters
                    click: () => {
                        $$('myForm2').clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button label for submitting filters
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from the form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('managementContact:filter', [
                            filterdata, // Trigger filter event with collected data
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup after submission
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Contains the first set of filters
                                    accordion_section, // Contains advanced filters
                                    buttons, // Contains action buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Contains the first set of filters and advanced filters
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains the filter sections and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get the current language
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
            $$('Datepicker').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang); // Set date modal configuration after rendering
            });
        });
    }
}

// FILE DOCUMENTED
